import { BrowserRouter } from "react-router-dom";
import Routes from "router/Routes";

import "styles/main.scss";
import "styles/toast.scss";

export default function App() {
   return (
      <BrowserRouter>
         <Routes/>
      </BrowserRouter>
   );
}
